"use client";

import { useRouter } from "next/navigation";
import { useErrorPageTranslations } from "../../../utils/error-page-translations-context";
import { useErrorHandler } from "../../../utils/hooks/use-error-handler";
import { ErrorPage } from "../../blocks/error-page/error-page";

interface LoginLayoutErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export function LoginLayoutError(props: Readonly<LoginLayoutErrorProps>) {
  const router = useRouter();
  const translations = useErrorPageTranslations();
  const { errorPageProps } = useErrorHandler({
    error: props.error,
    errorTranslations: translations,
  });

  function handleRetry() {
    props.reset();
    router.refresh();
  }

  return (
    <ErrorPage
      {...errorPageProps}
      buttonText={translations.button5xx}
      onButtonClick={handleRetry}
    />
  );
}
